(() => {
  const selector = '.mini-cart-vip .mini-cart__vip-membership-offer .tooltip-vip';

  function positionTooltip(tooltip) {
    const content = tooltip.querySelector('.tooltip-vip__content');
    if (!content) return;

    const drawer = tooltip.closest('.mini-cart-vip');
    const drawerBounds = drawer.getBoundingClientRect();
    let left = Math.max(0, drawerBounds.left);
    let right = Math.min(document.documentElement.clientWidth, drawerBounds.right);
    // Respect every scrolling/clipping ancestor, including the cart's item list.
    for (let parent = tooltip.parentElement; parent; parent = parent.parentElement) {
      if (/(auto|scroll|hidden|clip)/.test(getComputedStyle(parent).overflowX)) {
        const bounds = parent.getBoundingClientRect();
        left = Math.max(left, bounds.left + parent.clientLeft);
        right = Math.min(right, bounds.left + parent.clientLeft + parent.clientWidth);
      }
    }

    left += 12;
    right -= 12;
    const detail = content.querySelector('.tooltip-vip__detail');
    if (detail) {
      detail.style.maxWidth = `${Math.max(0, right - left)}px`;
      detail.style.boxSizing = 'border-box';
    }
    // Measure even before the hover style has made the popup visible.
    const previousDisplay = content.style.display;
    const previousVisibility = content.style.visibility;
    content.style.visibility = 'hidden';
    content.style.display = 'block';
    content.style.transition = 'opacity 0.2s, visibility 0.2s';
    content.style.transform = 'translateX(-50%)';
    const bounds = content.getBoundingClientRect();
    const targetLeft = Math.max(left, Math.min(bounds.left, right - bounds.width));
    content.style.transform = `translateX(calc(-50% + ${targetLeft - bounds.left}px))`;
    content.style.display = previousDisplay;
    content.style.visibility = previousVisibility;
  }

  // Delegation also handles cart HTML replaced after quantity/add-to-cart updates.
  for (const eventName of ['pointerover', 'focusin']) {
    document.addEventListener(eventName, (event) => {
      const tooltip = event.target.closest?.(selector);
      if (tooltip) {
        positionTooltip(tooltip);
        updateVisibleTooltips();
      }
    }, true);
  }

  let frame;
  function updateVisibleTooltips() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll(selector).forEach((tooltip) => {
        if (tooltip.matches(':hover, :focus-within')) positionTooltip(tooltip);
      });
    });
  }
  window.addEventListener('resize', updateVisibleTooltips);
  document.addEventListener('scroll', updateVisibleTooltips, true);
  document.addEventListener('transitionend', updateVisibleTooltips, true);
  updateVisibleTooltips();
})();
